import { INTENT_PROJECT_RESOURCES_COLUMN_ID } from "../constants";
import IntentProjectResourcesTableIdCell from "./IdCell";
import IntentProjectResourcesTableProviderCell from "./ProviderCell";
import IntentProjectResourcesTableTypeCell from "./TypeCell";
import IntentProjectResourcesTableRowActionsCell from "./RowActionsCell";

const INTENT_PROJECT_RESOURCES_TABLE_CELLS = {
  [INTENT_PROJECT_RESOURCES_COLUMN_ID.PROVIDER]: IntentProjectResourcesTableProviderCell,
  [INTENT_PROJECT_RESOURCES_COLUMN_ID.RESOURCE_TYPE]: IntentProjectResourcesTableTypeCell,
  [INTENT_PROJECT_RESOURCES_COLUMN_ID.RESOURCE_ID]: IntentProjectResourcesTableIdCell,
  [INTENT_PROJECT_RESOURCES_COLUMN_ID.ROW_ACTIONS]: IntentProjectResourcesTableRowActionsCell,
};

export default INTENT_PROJECT_RESOURCES_TABLE_CELLS;
